import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet';
import Header from './SaaSLandingHeader';
import Footer from './SaaSLandingFooter';

interface LayoutProps {
  children: React.ReactNode;
  isScrolled: boolean;
  isNavOpen: boolean;
  toggleNav: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, isScrolled, isNavOpen, toggleNav }) => {
  return (
    <div>
      <Helmet>
        <title>SaaS Platform - Multi-Tenant Management Solution</title>
        <meta
          name="description"
          content="Streamline your business with our multi-tenant SaaS platform, offering tenant management, subscriptions, support ticketing, and secure role-based access. Submit a tenant request today."
        />
        <meta
          name="keywords"
          content="SaaS platform, multi-tenant, tenant management, tenant request, subscriptions, support tickets, audit logging, notifications, role-based access"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Your SaaS Company" />
        <meta property="og:title" content="SaaS Platform - Multi-Tenant Management Solution" />
        <meta
          property="og:description"
          content="Discover our scalable SaaS platform for managing tenants, subscriptions, and support. Submit a tenant request to get started."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://your-saas-platform.com" />
        <meta
          property="og:image"
          content="https://placehold.co/1200x630/ffffff/1e40af?text=SaaS+Platform+Preview&font=Inter"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="SaaS Platform - Multi-Tenant Management Solution" />
        <meta
          name="twitter:description"
          content="Discover our scalable SaaS platform for managing tenants, subscriptions, and support. Submit a tenant request to get started."
        />
        <meta
          name="twitter:image"
          content="https://placehold.co/1200x630/ffffff/1e40af?text=SaaS+Platform+Preview&font=Inter"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "SaaS Platform",
              "operatingSystem": "Web",
              "applicationCategory": "BusinessApplication",
              "offers": [
                {
                  "@type": "Offer",
                  "price": "49",
                  "priceCurrency": "USD",
                  "name": "Basic Plan"
                },
                {
                  "@type": "Offer",
                  "price": "149",
                  "priceCurrency": "USD",
                  "name": "Pro Plan"
                },
                {
                  "@type": "Offer",
                  "name": "Enterprise Plan",
                  "price": "0",
                  "priceCurrency": "USD",
                  "availability": "http://schema.org/InStock"
                }
              ],
              "description": "A multi-tenant SaaS platform for managing tenants, subscriptions, support tickets, and more with secure role-based access.",
              "url": "https://your-saas-platform.com"
            }
          `}
        </script>
      </Helmet>
      <Header isScrolled={isScrolled} isNavOpen={isNavOpen} toggleNav={toggleNav} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
